import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * KPICard
 * @param {React.ReactNode} icon   - Icon element to display inside the circle
 * @param {string}          label  - Small label text (e.g. "Total assets")
 * @param {string|number}   value  - Large value to display (e.g. 219)
 * @param {string}          iconBgColor - Background color of the icon circle (default purple)
 */
export default function KPICard({ icon, label, value, iconBgColor = "#7B52AB" }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                backgroundColor: "#1E1B2E",
                borderRadius: "0.75rem",
                px: 2.5,
                py: 1.75,
                minWidth: 160,
            }}
        >
            {/* Icon circle */}
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    backgroundColor: iconBgColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    color: "#fff",
                    fontSize: 24,
                }}
            >
                {icon}
            </Box>

            {/* Label & Value */}
            <Box>
                <Typography
                    variant="caption"
                    sx={{
                        color: "#919EAB",
                        fontSize: "0.75rem",
                        lineHeight: 1.2,
                        display: "block",
                    }}
                >
                    {label}
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        color: "#FFFFFF",
                        fontWeight: 700,
                        lineHeight: 1.2,
                    }}
                >
                    {value}
                </Typography>
            </Box>
        </Box>
    );
}
